import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { ProjectIcon } from '@/const'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import { Link } from 'react-router'
import { useCurrentProject } from './useCurrentProject'

export function ProjectsBreadcrumbs({ title }: { title: string }) {
  const { projectId, name } = useCurrentProject()

  return (
    <Breadcrumb className="backdrop-blur">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link className="hover:text-primary hover:underline" to="/projects">
              Projects
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <IconRightChevronOutline />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link className="flex items-center hover:text-primary hover:underline" to={`/projects/${projectId}`}>
              <ProjectIcon className="mr-2 size-5" />
              {name}
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <IconRightChevronOutline />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <BreadcrumbPage>{title}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
